import React, { useEffect } from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import { PageContainer, PageControlSkeleton } from 'src/common';
import { useParams } from 'react-router';
import { MetaSheetScenario } from './comps';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import { useScenarioTemplatesQuery } from 'src/graphql/_generated';

const ScenarioTemplatePage = () => {
  const { scenarioTemplateId } = useParams<{ scenarioTemplateId: string }>();
  const { setLocationPaths } = useActionsApp();

  const { data: { scenarioTemplates = [] } = {} } = useScenarioTemplatesQuery();
  const scenarioTemplate = scenarioTemplates.find((template) => template.id === scenarioTemplateId);

  useEffect(() => {
    if (scenarioTemplate) {
      setLocationPaths({
        scenarioTemplate: { id: scenarioTemplate.id, name: scenarioTemplate.name! },
      });
    }
    return () => {
      setLocationPaths({ scenarioTemplate: undefined });
    };
  }, [scenarioTemplate]);

  useGaEventPageView(`Cydea | Scenario | ${scenarioTemplate?.name}`);

  return (
    <>
      <Meta title={`Cydea | Scenario | ${scenarioTemplate?.name}`} feedbackScript />
      <PageContainer>
        {scenarioTemplate ? <MetaSheetScenario data={scenarioTemplate} /> : <PageControlSkeleton />}
      </PageContainer>
    </>
  );
};

export default ScenarioTemplatePage;
